var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCoinStack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8129 3.51853C10.8139 2.49537 8.72756 1.66666 6.15693 1.66666C3.5863 1.66666 1.50186 2.49629 1.5 3.51853M1.5 3.51853C1.5 4.54169 3.58444 5.3704 6.15693 5.3704C8.72942 5.3704 10.8139 4.54169 10.8139 3.51853L10.8139 10.7037M1.5 3.51853V14.6297C1.50093 15.6528 3.58537 16.4816 6.15693 16.4816C7.40406 16.4816 8.5301 16.2843 9.36556 15.9667M1.50093 7.22225C1.50093 8.24541 3.58538 9.07413 6.15787 9.07413C8.73036 9.07413 10.8148 8.24541 10.8148 7.22225M9.42144 12.2455C8.58133 12.5742 7.42921 12.7779 6.15693 12.7779C3.58537 12.7779 1.50093 11.9492 1.50093 10.926M16.106 11.2205C17.7424 12.8474 17.7424 15.4863 16.106 17.1132C14.4696 18.74 11.8151 18.74 10.1787 17.1132C8.54221 15.4863 8.54221 12.8474 10.1787 11.2205C11.8151 9.59365 14.4696 9.59365 16.106 11.2205Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCoinStack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/coin-stack.051bdcf6.svg";
export { ForwardRef as ReactComponent };